// 1:1 wrapper around apiv2 `clinical_view.get_patient_home` (ACL_Session, POST).
// Session-authed via ws() — same coordinator scope get_patient_file uses
// (SCOPE_CLINICAL_COORDINATOR_AND_REQUIRED_PATIENT). NOT WF50, NOT n8n.
// BACK-OFFICE ONLY: a coordinator/service session gets the payload UNFILTERED;
// never reuse this in a patient-facing context (server-side patient redaction is
// the real boundary — the client filters in logic/patientHome are fidelity-only).
// Throws (WsError) on non-OK status — see services convention.

import { ws } from '@/lib/wiservice';
import type { PatientHomeView } from './types';

export interface ClinicalViewPatientHomeBody {
  data?: PatientHomeView;
  meta?: { generated_at?: string };
}

export async function getPatientHome(params: Record<string, unknown>): Promise<ClinicalViewPatientHomeBody> {
  const res = await ws<ClinicalViewPatientHomeBody>('clinical_view', 'get_patient_home', params);
  return res.body;
}
